import React from 'react';

import { PageTitle } from '../../../components';
import { Registration } from '../../../sections';



const RegistrationPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Registration'} page={'Registration'} />

      {/* Registration Section */}
      <Registration />

    </>

  );

}

export default RegistrationPage;